import { render, staticRenderFns } from "./editFollowUp.vue?vue&type=template&id=1748208b&scoped=true&"
import script from "./editFollowUp.vue?vue&type=script&lang=js&"
export * from "./editFollowUp.vue?vue&type=script&lang=js&"
import style0 from "./editFollowUp.vue?vue&type=style&index=0&id=1748208b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1748208b",
  null
  
)

export default component.exports